<template>
    <div>
        <div v-if="form || (form && form.translations && showTranslation)">
            <b-form-row>
                <slot>
                    <b-col>
                        <FormElementInput name="namn" v-model="elementValueName" @input="elementValueName = $event" />
                    </b-col>
                    <b-col cols="3">
                        <FormElementInput name="artnr" v-model="elementValueArtnr"
                            @input="elementValueArtnr = $event" />
                    </b-col>
                    <b-col cols="3" v-if="showOriginal">
                        <FormElementInput name="enr" v-model="elementValueEnr" @input="elementValueEnr = $event" />
                    </b-col>
                    <b-col cols="3" v-if="showTranslation">
                        <FormElementInput name="nobnr" v-model="elementValueNobnr"
                            @input="elementValueNobnr = $event" />
                    </b-col>
                </slot>
            </b-form-row>
            <FormSectionInfo v-model="elementValueInfo" @input="elementValueInfo = $event" />
            <b-form-row v-if="showOriginal">
                <b-col>
                    <b-form-checkbox :disabled="!canPublishSE" v-model="form.published" switch>
                        {{ $t("text.admin.published") }} <small>{{ $t("text.admin.published-help") }}</small>
                    </b-form-checkbox>
                </b-col>
            </b-form-row>
            <div v-if="showTranslation">
                <b-form-row>
                    <b-col>
                        <b-form-checkbox :disabled="!canPublishXX" v-model="form.translations[langcode].published"
                            switch>
                            {{ $t("text.admin.published") }} <small>{{ $t("text.admin.published-help") }}</small>
                        </b-form-checkbox>
                    </b-col>
                </b-form-row>
                <div class="mt-5" v-if="showTranslation">
                    <label>{{ $t("text.admin.sampletext-orig") }}</label>
                    <b-card class="shadow-sm" no-body bg-variant="light">
                        <div class="d-flex justify-content-between">
                            <h3 class="m-3">{{ form.name }}</h3>
                            <div class="my-3 ml-auto">{{ form.artnr }}</div>
                            <div class="mt-2">
                                <country-flag country="se" size="normal" class="mr-0 ml-0" />
                            </div>
                        </div>
                        <div class="px-3">
                            <dl v-for="(info, i) in form.info" v-bind:key="`product-info-${i}`">
                                <div v-if="info.body">
                                    <dt>{{ info.title }}</dt>
                                    <dd v-html="sanitize(info.body)" class="pre-wrap"></dd>
                                </div>
                            </dl>
                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormElementInput from "@/components/admin/form/FormElementInput";
import AdminElementsMixin from "@/mixins/AdminElementsMixin";
import AdminAccessMixin from "@/mixins/AdminAccessMixin";
import FormSectionInfo from "@/components/admin/form/FormSectionInfo";
import DOMPurify from "dompurify";

export default {
    name: 'AdminProductBaseSettings',
    mixins: [AdminElementsMixin, AdminAccessMixin],
    props: {
        form: Object,
    },
    methods: {
        sanitize(html) {
            return DOMPurify.sanitize(html);
        }
    },
    components: {
        FormElementInput,
        FormSectionInfo
    },
    computed: {
        canPublishSE() {
            return this.form.name && this.form.artnr && this.form.info[0].body;
        },
        canPublishXX() {
            return this.form.translations && this.form.translations[this.langcode] && this.form.translations[this.langcode].name && this.form.translations[this.langcode].artnr && this.form.translations[this.langcode].info[0].body;
        },
    }
}
</script>

<style lang="scss" scoped>
    .pre-wrap {
        white-space: pre-wrap;
    }
</style>